import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=333765e8&scoped=true"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=333765e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333765e8",
  null
  
)

export default component.exports